import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { MarketRateImpl } from "../model/impl/MarketRateImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class MarketRateImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: MarketRateImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.askPrice != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        MarketRateImplEncoder.fidTypeMap.get(1),
        false,
        encodable.askPrice,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.askSize != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        MarketRateImplEncoder.fidTypeMap.get(2),
        false,
        encodable.askSize,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.bidPrice != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        MarketRateImplEncoder.fidTypeMap.get(3),
        false,
        encodable.bidPrice,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.bidSize != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        MarketRateImplEncoder.fidTypeMap.get(4),
        false,
        encodable.bidSize,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.tenor != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        MarketRateImplEncoder.fidTypeMap.get(5),
        false,
        encodable.tenor,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.valueDate != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        MarketRateImplEncoder.fidTypeMap.get(6),
        true,
        encodable.valueDate,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.isTradable != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        MarketRateImplEncoder.fidTypeMap.get(7),
        false,
        encodable.isTradable,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.publicationTime != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        MarketRateImplEncoder.fidTypeMap.get(8),
        false,
        encodable.publicationTime,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.rateId != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        false,
        MarketRateImplEncoder.fidTypeMap.get(9),
        false,
        encodable.rateId,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.ndfHorizon != null) {
      this.baseEncoder.writeStartFid(10, streamout);
      this.baseEncoder.writeObject(
        false,
        MarketRateImplEncoder.fidTypeMap.get(10),
        false,
        encodable.ndfHorizon,
        streamout,
      );
      this.baseEncoder.writeEndFid(10, streamout);
    }
    /*Object encoding*/
    if (encodable.fixingTime != null) {
      this.baseEncoder.writeStartFid(11, streamout);
      this.baseEncoder.writeObject(
        false,
        MarketRateImplEncoder.fidTypeMap.get(11),
        false,
        encodable.fixingTime,
        streamout,
      );
      this.baseEncoder.writeEndFid(11, streamout);
    }
    /*Object encoding*/
    if (encodable.product != null) {
      this.baseEncoder.writeStartFid(12, streamout);
      this.baseEncoder.writeObject(
        false,
        MarketRateImplEncoder.fidTypeMap.get(12),
        false,
        encodable.product,
        streamout,
      );
      this.baseEncoder.writeEndFid(12, streamout);
    }
    /*Object encoding*/
    if (encodable.numPips != null) {
      this.baseEncoder.writeStartFid(13, streamout);
      this.baseEncoder.writeObject(
        false,
        MarketRateImplEncoder.fidTypeMap.get(13),
        false,
        encodable.numPips,
        streamout,
      );
      this.baseEncoder.writeEndFid(13, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        MarketRateImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,MarketRateImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.math.BigDecimal"],
    [2, "java.lang.Double"],
    [3, "java.math.BigDecimal"],
    [4, "java.lang.Double"],
    [5, "com.bcdfx.model.Tenor"],
    [6, "com.bcdfx.model.StandardDate"],
    [7, "java.lang.Boolean"],
    [8, "java.lang.Long"],
    [9, "java.lang.String"],
    [10, "java.lang.Boolean"],
    [11, "java.lang.Long"],
    [12, "com.bcdfx.model.Product"],
    [13, "java.lang.Integer"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: MarketRateImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            MarketRateImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.askPrice = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            MarketRateImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.askSize = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            MarketRateImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.bidPrice = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            MarketRateImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.bidSize = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: CubiqTS.Tenor = this.baseEncoder.readObject(
            false,
            false,
            MarketRateImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.tenor = <CubiqTS.Tenor>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: CubiqTS.StandardDate = this.baseEncoder.readObject(
            true,
            false,
            MarketRateImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.valueDate = <CubiqTS.StandardDate>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            MarketRateImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.isTradable = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            MarketRateImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.publicationTime = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            MarketRateImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.rateId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            MarketRateImplEncoder.fidTypeMap.get(10),
            streamin,
          );
          encodable.ndfHorizon = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 11: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            MarketRateImplEncoder.fidTypeMap.get(11),
            streamin,
          );
          encodable.fixingTime = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 12: {
          /*Object encoding*/
          let val: CubiqTS.Product = this.baseEncoder.readObject(
            false,
            false,
            MarketRateImplEncoder.fidTypeMap.get(12),
            streamin,
          );
          encodable.product = <CubiqTS.Product>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 13: {
          /*Object encoding*/
          let val: number = this.baseEncoder.readObject(
            false,
            false,
            MarketRateImplEncoder.fidTypeMap.get(13),
            streamin,
          );
          encodable.numPips = <number>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            MarketRateImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,MarketRateImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return MarketRateImplEncoder.fidTypeMap.has(fid);
  }
}
